module.exports = __webpack_public_path__ + "img/20_55.3f8e319d.png";